<template>
    <div :class="['audio-player',{'is-playing': isPlaying}]">
        <play-button v-if="!playerId" :file-id="fileId" :file-url="fileUrl" :description="description"></play-button>
        <div class="waveform" @click.prevent="clickWaveform" v-if="fileId && waveFormImageTemplate != null">
            <img class="off" :src="waveformImagePath" alt="" draggable="false">
            <div class="on" :style="'width:' + currentPercentage + '%'">
                <img :src="waveformImagePath" alt="" draggable="false">
            </div>
        </div>
        <div class="times" v-if="fileId && totalTime !== null">
            <div class="current">{{ currentTimeFormatted }}</div>
            <div class="total">{{ totalTimeFormatted }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        fileId: {
            type: String,
            default: null,
        },
        fileUrl: {
            type: String,
            default: null,
        },
        waveFormImageTemplate: {
            type: String,
            default: null
        },
        totalTime: {
            type: Number,
            default: null
        },
        playerId: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        }
    },
    data: function () {
		return {
            fileFolder: '/files/audio/',
            currentTime: 0,
            audioElement: null,
            isPlaying: false,
		}
	},
	methods: {
        clickWaveform(event) {
            const percentage = Math.floor(event.offsetX / event.target.width * 100);
            const seconds = (this.totalTime / 100) * percentage;

            // emit waveform click
            this.$root.$emit('clickWaveform', {
                fileId:this.fileId,
                fileUrl:this.fileUrl,
                seconds:seconds,
            });
        },
        timeUpdate(seconds) {
            this.currentTime = seconds;
        },
        formatTime(seconds) {
            let m = Math.floor(seconds / 60);
            let s = seconds % 60;

            if (m<10) {
                m = '0' + m;
            }

            if (s<10) {
                s= '0' + s;
            }

            return m + ':' + s;
        },
        reset() {
            this.currentTime = 0;
        },
    },
    computed: {
        currentTimeFormatted() {
            return this.formatTime(Math.round(this.currentTime));
        },
        totalTimeFormatted() {
            return this.formatTime(Math.round(this.totalTime));
        },
        waveformImagePath() {
            return '/waveforms/' +  this.waveFormImageTemplate + '/' + this.fileId + '.svg';
        },
        currentPercentage() {
            return this.currentTime / this.totalTime * 100;
        }
    },
    mounted() {
        var vm = this;

        this.$root.$on('audioElementTimeUpdate',data => {
            if (data.fileId && data.fileId==vm.fileId) {
                this.timeUpdate(data.seconds);
            }
            if (data.fileUrl && data.fileUrl==vm.fileUrl) {
                this.timeUpdate(data.seconds);
            }
        });

        this.$root.$on('audioElementResets',data => {
            this.reset();
        });
    },
}
</script>
